import { curveLinear, curveMonotoneX } from 'd3-shape';

import { SeriesCurve } from '../../../types/timeseries.js';

/**
 * Maps the curve string to a valid d3 shape.
 * @internal
 * @param curve - The curve string.
 */
export const mapSeriesCurveToD3 = (curve: SeriesCurve) => {
  if (curve === 'smooth') {
    return curveMonotoneX;
  } else {
    return curveLinear;
  }
};
